import { Font, Page, StyleSheet } from '@react-pdf/renderer';
import { theme } from '../theme';
import {
  arialRegularFontData,
  arialBoldFontData,
} from '../font/arial/arialFontData';

Font.register({
  family: 'Arial',
  fonts: [
    { src: arialRegularFontData },
    { src: arialBoldFontData, fontWeight: 'bold' },
  ],
});

const style = StyleSheet.create({
  pdfStandardPageStyle: {
    width: '100%',
    padding: '40px',

    display: 'flex',
    flexDirection: 'column',

    backgroundColor: theme.colors.primaryW,
    fontFamily: 'Arial',
    fontSize: '9px',
    color: theme.colors.primaryK10,
  },
});

export const PdfStandardPage: React.FC = ({ ...props }) => (
  <Page size="A4" style={style.pdfStandardPageStyle}>
    {props.children}
  </Page>
);
